import { Component } from '@angular/core';

@Component({
  selector: 'authentication-page',
  templateUrl: './authentication.component.html',
})
export class AuthenticationComponent {
}

